import { combineReducers } from 'redux';
import { messageReducer } from '.';
import {  userReducer } from './user/Reducer'
import profileReducer from './profile/Reducer'
import exerciseReducer from './exercises/Reducer'
import  { milestoneReducer } from './milestones/Reducer'
import { resourceReducer} from './resources/Reducer';
import { subscriptionReducer } from './subscription/Reducer'
import { childrenReducer } from './children/Reducer'
import {toyReducer } from './toys/Reducer';
import { giftReducer} from './gift/Reducer';
export const RootReducer = combineReducers({
	users: userReducer,
	messages: messageReducer,
	profile:profileReducer,
	exercise:exerciseReducer,
	milestones:milestoneReducer,
	resources:resourceReducer,
	subscriptions:subscriptionReducer,
	children:childrenReducer,
	toys:toyReducer,
	gifts:giftReducer
});
